import { all, takeEvery, fork, put } from 'redux-saga/effects';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';
const gaxios = require('gaxios');

gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
}


export function* filterAction() {
  yield takeEvery(actions.FILTER_ATTRIBUTE, function*() {});
}

function* getEmails(action) {
  let ULRDestino = "api/mensajes/user/"+action.userId;
  let metodo = "GET";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if( !res.data.success ){
    notification('success', res.data.msg )
  }else{
    console.log(res.data)
    yield put({
      type: actions.FORMAT_MAILS,
      data: res.data.mensajes,
    });
  }
}

function* updateEmail(action) {
  console.log(action)
  let ULRDestino = "api/mensajes/user/"+action.userId;
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if( !res.data.success ){
    notification('success', res.data.msg )
  }else{
    console.log(res.data)
    // yield put({
    //   type: actions.FORMAT_MAILS,
    //   data: res.data.mensajes,
    // });
  }
}

export default function* rootSaga() {
  yield all([fork(filterAction)]);
  yield all([takeEvery(actions.GET_MAILS, getEmails)]);
  yield all([takeEvery(actions.UPDATE_MAIL, updateEmail)]);
}
